<!--
 * @Description: 
 * @Autor: wanglu
 * @Date: 2021-10-11 09:59:07
 * @LastEditors: 王璐 wanglu@longjitech.com
 * @LastEditTime: 2022-08-02 17:55:52
 * @FilePath: /ljsite-vue/src/App.vue
-->
<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <template #renderEmpty>
        <a-empty description="暂无数据"></a-empty>
      </template>
      <router-view v-if="isRouterAlive" />
    </a-config-provider>
    <personal-info-protection-notice />
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import PersonalInfoProtectionNotice from "@/components/compliance/PersonalInfoProtectionNotice.vue";
export default {
  components: {
    PersonalInfoProtectionNotice,
  },
  data() {
    return {
      isRouterAlive: true,
      locale: zhCN,
      baseFontSize: 16 // 初始的基础字体大小，单位为px
    };
  },
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  mounted() {
        // 页面加载完成时先调用一次
        this.setBaseFontSize();

        // 监听窗口大小变化事件，当窗口大小变化时重新计算和设置字体大小
        window.addEventListener('resize', this.setBaseFontSize);
  },
  methods: {
    setBaseFontSize() {
            // 获取当前窗口宽度
            var ratio = window.outerWidth / window.innerWidth
            var windowWidth = window.innerWidth * ratio;

            // 计算新的 baseFontSize，例如每 50px 宽度增加 1px 字体大小
            this.baseFontSize = windowWidth / 120;

            // 设置根元素的字体大小
            document.documentElement.style.fontSize = this.baseFontSize + 'px';
      },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>
<style lang="less" scoped>
//解决官网滚动条问题（整体加上overflow：hidden）
#app {
  width: 100%;
  // overflow: hidden;
}
/deep/.resize-table-th {
  position: relative;
  background-clip: padding-box !important;
  .table-draggable-handle {
    height: 44px !important;
    bottom: 0;
    left: auto !important;
    right: -5px;
    z-index: 1;
    width: 30px !important;
    cursor: col-resize;
    touch-action: none;
    position: absolute;
    transform: translate(0px, 0px) !important;
  }
  cursor: pointer;
  .ant-table-header-column {
    user-select: none;
    -webkit-user-select: none;
  }
}
</style>

